import { Icon } from "@iconify/react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDocs,
  onSnapshot,
} from "firebase/firestore";
import { db } from "../../Firebase/Config";
import RouteWithTitle from "../../Layout/RouteWithTitle";
import Showmodal from "../ShowModal/ShowModal";
import Loading from "../../Home-Page/Main/Loading/Loading";

function Showservice() {
  const navigate = useNavigate();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const onSubmit = async (newInformation) => {
    try {
      const ref = collection(db, "service");

      const snapshot = await getDocs(ref);
      const Id = snapshot.size + 1;
      newInformation.Id = Id;

      await addDoc(ref, newInformation);
      navigate("/admin/create/service");
    } catch (error) {
      console.error(error);
    }
  };

  const onDelete = async (id) => {
    try {
      await deleteDoc(doc(db, "service", id.toString()));
      setData(data.filter((item) => item.id !== id));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    setLoading(true);
    const ref = collection(db, "service");
    getDocs(ref).then((snapshot) => {
      if (snapshot.empty) {
        setError("خطایی رخ داد");
        setLoading(false);
      } else {
        setLoading(false);
        const unsubscribe = onSnapshot(ref, (snapshot) => {
          let result = [];
          snapshot.docs.forEach((doc) => {
            result.push({ id: doc.id, ...doc.data() });
          });
          setData(result);
        });
        return () => unsubscribe();
      }
    });
  }, []);

  return (
    <>
      <RouteWithTitle>
        <div className="flex flex-col bg-slate-700 h-full p-5 overflow-y-scroll text-white">
          <div className="flex pb-5">
            <Showmodal
              hiddenHref
              hiddenSize
              title={"سرویس ها"}
              button={"ایجاد سرویس"}
              onSubmit={onSubmit}
            />
          </div>
          <div className="flex">
            <table className="w-full">
              <thead>
                <tr>
                  <th className="p-2">تعداد</th>
                  <th className="p-2">عکس</th>
                  <th className="p-2">تیتر</th>
                  <th className="p-2">متن</th>
                  <th className="p-2">پاک کردن</th>
                </tr>
              </thead>
              {error ? (
                error
              ) : loading ? (
                <tbody>
                  <tr>
                    <td>
                      <Loading />
                    </td>
                  </tr>
                </tbody>
              ) : data ? (
                <tbody>
                  {data
                    .sort((a, b) => a.Id - b.Id)
                    .map((item) => (
                      <tr key={item.id}>
                        <th className="border p-2">{item.Id}</th>
                        <td className="w-28 h-28 border p-2 flex justify-center">
                          <img src={item.Picture} alt={item.Title} />
                        </td>
                        <td className="border p-2">{item.Title}</td>
                        <td className="border p-2">{item.Description}</td>
                        <td className="border p-2">
                          <Icon
                            icon="mingcute:delete-line"
                            wirth="30"
                            height="30"
                            className="cursor-pointer mr-2 mt-1"
                            onClick={() => onDelete(item.id)}
                          />
                        </td>
                      </tr>
                    ))}
                </tbody>
              ) : (
                <tbody>
                  <tr>
                    <td>
                      <p>داده‌ای وجود ندارد</p>
                    </td>
                  </tr>
                </tbody>
              )}
            </table>
          </div>
        </div>
      </RouteWithTitle>
    </>
  );
}

export default Showservice;
